<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 56 32"
  >
    <g :fill="color" class="fill-current">
      <path
        d="M38.879 0.44l-0.885 0.885c-0.271 0.272-0.439 0.646-0.439 1.061s0.168 0.789 0.439 1.061v0l10.49 10.43h-46.983c-0.829 0-1.5 0.672-1.5 1.5v0 1.249c0 0.829 0.672 1.5 1.5 1.5v0h46.986l-10.49 10.43c-0.271 0.271-0.439 0.646-0.439 1.061s0.168 0.789 0.439 1.061l0.885 0.885c0.272 0.271 0.646 0.439 1.061 0.439s0.789-0.168 1.061-0.439v0l14.559-14.5c0.271-0.271 0.439-0.646 0.439-1.061s-0.168-0.789-0.439-1.061v0l-14.564-14.502c-0.271-0.271-0.646-0.438-1.059-0.438s-0.788 0.167-1.059 0.438l0-0z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
